/**
 * 로그아웃을 요청한다. `POST /app/auths/logout`.
 *
 * `src/hooks/useLogout.ts` 에서 부른다. 로그인된 세션을 서버에서 무효화해야 하므로
 * 인증이 붙은 `axiosInstance` 를 쓴다.
 *
 * 주의: 이 파일은 `pages/api/` 안에 있지만 서버에서 도는 코드가 아니다.
 */
import api from "../axiosInstance";

/** 로그아웃 응답 형태. */
export interface LogoutResponse {
  isSuccess: boolean;
  code: number;
  message: string;
}

/** @returns 성공/실패 여부를 담은 응답. 요청 자체가 실패하면 null(예외를 던지지 않는다). */
export const logout = async (): Promise<LogoutResponse | null> => {
  try {
    const response = await api.post<LogoutResponse>("/app/auths/logout", {});
    return response.data;
  } catch (error: any) {
    console.error("로그아웃 처리 중 에러 발생:", error);
    return null;
  }
};

// import { getApiBaseUrl } from "@/utils/getApiBaseUrl";
// import api from "../axiosInstance";

// export const logout = async () => {
//   try {
//     const baseURL = getApiBaseUrl();
//     const accessToken = sessionStorage.getItem("accessToken");

//     const response = await api.post(
//       `${baseURL}/app/auths/logout`,
//       {}
//       // {
//       //   headers: {
//       //     "Content-Type": "application/json",
//       //     Authorization: `Bearer ${accessToken}`,
//       //   },
//       //   withCredentials: true,
//       // }
//     );

//     if (response.status === 200) {
//       return { isSuccess: true };
//     } else {
//       return { isSuccess: false };
//     }
//   } catch (error) {
//     console.error("로그아웃 요청 실패:", error);
//     return { isSuccess: false };
//   }
// };
